/**
 * MÔJ PROFIL.
 *
 * Heslo a podpis do mailov si musí vedieť zmeniť každý zamestnanec, aj keď sa
 * do Nastavení nedostane – tie sú len pre administrátora. Preto je toto okno
 * v ľavom stĺpci pri mene, nie v Nastaveniach.
 */
import { useEffect, useState } from 'react';
import { KeyRound, PenLine, Bell } from 'lucide-react';
import { api } from '../api';
import { Modal, Input, useToast } from './ui';
import PodpisEditor from './PodpisEditor';
import Upozornenia from './Upozornenia';

export default function MojProfil({ open, onClose }) {
  const toast = useToast();
  const [zalozka, setZalozka] = useState('podpis');
  const [busy, setBusy] = useState(false);
  const [stareHeslo, setStareHeslo] = useState('');
  const [noveHeslo, setNoveHeslo] = useState('');

  useEffect(() => {
    if (!open) return;
    setStareHeslo('');
    setNoveHeslo('');
  }, [open]);

  if (!open) return null;

  const zmenHeslo = async () => {
    setBusy(true);
    try {
      await api.post('/api/auth/change-password', { old_password: stareHeslo, new_password: noveHeslo });
      toast.success('Heslo zmenené.');
      setStareHeslo('');
      setNoveHeslo('');
    } catch (e) { toast.error(e.message); }
    finally { setBusy(false); }
  };

  return (
    <Modal
      open wide onClose={onClose} title="Môj profil"
      footer={(
        <>
          <button className="btn-ghost" onClick={onClose}>Zavrieť</button>
          {zalozka === 'heslo' && (
            <button className="btn-primary" disabled={busy || noveHeslo.length < 4} onClick={zmenHeslo}>
              Zmeniť heslo
            </button>
          )}
        </>
      )}
    >
      <div className="mb-3 flex gap-2">
        <button className={`chipbtn ${zalozka === 'podpis' ? 'chipbtn-on' : ''}`} onClick={() => setZalozka('podpis')}>
          <PenLine size={13} /> Podpis do mailov
        </button>
        <button className={`chipbtn ${zalozka === 'heslo' ? 'chipbtn-on' : ''}`} onClick={() => setZalozka('heslo')}>
          <KeyRound size={13} /> Zmena hesla
        </button>
        {/* Upozornenia sú tu, nie v Nastaveniach: zapína si ich každý sám
            a na svojom zariadení – do Nastavení sa dostane len administrátor. */}
        <button className={`chipbtn ${zalozka === 'upozornenia' ? 'chipbtn-on' : ''}`}
          onClick={() => setZalozka('upozornenia')}>
          <Bell size={13} /> Upozornenia
        </button>
      </div>

      {zalozka === 'podpis' ? (
        <PodpisEditor />
      ) : zalozka === 'upozornenia' ? (
        <Upozornenia />
      ) : (
        <div className="max-w-sm space-y-3">
          <Input label="Staré heslo" type="password" value={stareHeslo}
            onChange={(e) => setStareHeslo(e.target.value)} autoComplete="current-password" />
          <Input label="Nové heslo" type="password" value={noveHeslo}
            onChange={(e) => setNoveHeslo(e.target.value)} autoComplete="new-password"
            hint="Aspoň 4 znaky. Ak sa prihlasujete kódom, je to zároveň váš kód." />
        </div>
      )}
    </Modal>
  );
}
